/* eslint-disable */
import React from 'react';
import { SelectItem } from 'components';
import styles from './ShareView.module.scss';
import { useFeatureFlagState } from 'context';
import { useShareToPerson, useShareToGroup } from 'services/apollo/hooks';
import { OrganizationTypes } from 'helpers/constants';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const ANIMATION_DURATION = 0.8 * 1000;

interface GroupSharingProps {
  nodeId: string;
  groupTargets: any;
}

export const GroupSharing: React.FC<GroupSharingProps> = ({ nodeId, groupTargets }) => {
  const [shareNodeToGroup] = useShareToGroup();

  return (
    <>
      {groupTargets?.targets?.length ? <div className={styles.sectionHeading}>Groups</div> : null}
      <TransitionGroup className={styles.transitionGroup}>
        {groupTargets?.targets
          ?.filter((target: any) => target.__typename === 'ShareTargetGroup')
          .map((group: any, key: number) => (
            <CSSTransition
              className={styles.transition}
              classNames={{ exit: styles.transitionExit }}
              key={group.id + nodeId}
              timeout={ANIMATION_DURATION}
            >
              {/* 
              // @ts-ignore */}
              <SelectItem
                checkbox="Circle"
                checked={false}
                group={group}
                name={group.groupName}
                isGroup
                onClick={() => {
                  shareNodeToGroup(nodeId, group.id, group.groupName);
                }}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
    </>
  );
};

interface SharingWorkAccountProps {
  nodeId: string;
  orgPeopleTargets: any;
  otherPeopleTargets: any;
  organizationName: any;
}

export const SharingWorkAccountView: React.FC<SharingWorkAccountProps> = ({
  nodeId,
  orgPeopleTargets,
  otherPeopleTargets,
  organizationName,
}) => {
  const [shareNodeToPerson] = useShareToPerson();

  return (
    <>
      {orgPeopleTargets?.targets?.length ? (
        <div className={styles.sectionHeading}>{organizationName}</div>
      ) : null}
      <TransitionGroup className={styles.transitionGroup}>
        {orgPeopleTargets?.targets
          ?.filter((target: any) => target.__typename === 'ShareTargetPerson')
          .map((contact: any, key: number) => (
            <CSSTransition
              className={styles.transition}
              classNames={{ exit: styles.transitionExit }}
              key={contact.id}
              timeout={ANIMATION_DURATION}
            >
              {/* 
                // @ts-ignore */}
              <SelectItem
                checkbox="Circle"
                checked={false}
                name={contact.name}
                imgURL={contact.avatarUrl}
                onClick={() => {
                  shareNodeToPerson(
                    nodeId,
                    contact.id,
                    contact.avatarUrl,
                    contact.isOrgMember,
                    contact.name,
                    contact.email
                  );
                }}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
      {otherPeopleTargets?.targets?.length ? (
        <div className={styles.sectionHeading}>Other People</div>
      ) : null}
      <TransitionGroup className={styles.transitionGroup}>
        {otherPeopleTargets?.targets
          ?.filter((target: any) => target.__typename === 'ShareTargetPerson')
          .map((contact: any, key: number) => (
            <CSSTransition
              className={styles.transition}
              classNames={{ exit: styles.transitionExit }}
              key={contact.id}
              timeout={ANIMATION_DURATION}
            >
              {/* 
                // @ts-ignore */}
              <SelectItem
                key={key}
                checkbox="Circle"
                checked={false}
                name={contact.name}
                imgURL={contact.avatarUrl}
                onClick={() => {
                  shareNodeToPerson(
                    nodeId,
                    contact.id,
                    contact.avatarUrl,
                    contact.isOrgMember,
                    contact.name,
                    contact.email
                  );
                }}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
    </>
  );
};

interface SharingPersonalAccountProps {
  nodeId: string;
  orgPeopleTargets: any;
  otherPeopleTargets: any;
}

export const SharingPersonalAccountView: React.FC<SharingPersonalAccountProps> = ({
  nodeId,
  orgPeopleTargets,
  otherPeopleTargets,
}) => {
  const [shareNodeToPerson] = useShareToPerson();

  return (
    <>
      {orgPeopleTargets?.targets?.length || otherPeopleTargets?.targets?.length ? (
        <div className={styles.sectionHeading}>People</div>
      ) : null}
      <TransitionGroup className={styles.transitionGroup}>
        {orgPeopleTargets?.targets
          ?.filter((target: any) => target.__typename === 'ShareTargetPerson')
          .map((contact: any, key: number) => (
            <CSSTransition
              className={styles.transition}
              classNames={{ exit: styles.transitionExit }}
              key={contact.id}
              timeout={ANIMATION_DURATION}
            >
              {/* 
                // @ts-ignore */}
              <SelectItem
                key={key}
                checkbox="Circle"
                checked={false}
                name={contact.name}
                imgURL={contact.avatarUrl}
                onClick={() => {
                  shareNodeToPerson(
                    nodeId,
                    contact.id,
                    contact.avatarUrl,
                    contact.isOrgMember,
                    contact.name,
                    contact.email
                  );
                }}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
      <TransitionGroup className={styles.transitionGroup}>
        {otherPeopleTargets?.targets
          ?.filter((target: any) => target.__typename === 'ShareTargetPerson')
          .map((contact: any, key: number) => (
            <CSSTransition
              className={styles.transition}
              classNames={{ exit: styles.transitionExit }}
              key={contact.id}
              timeout={ANIMATION_DURATION}
            >
              {/* 
                // @ts-ignore */}
              <SelectItem
                key={key}
                checkbox="Circle"
                checked={false}
                name={contact.name}
                imgURL={contact.avatarUrl}
                onClick={() => {
                  shareNodeToPerson(
                    nodeId,
                    contact.id,
                    contact.avatarUrl,
                    contact.isOrgMember,
                    contact.name,
                    contact.email
                  );
                }}
              />
            </CSSTransition>
          ))}
      </TransitionGroup>
    </>
  );
};
interface ShareViewProps {
  nodeId: string;
  groupTargets: any;
  orgPeopleTargets: any;
  otherPeopleTargets: any;
  organizationType: any;
  organizationName?: any;
}
export const ShareView: React.FC<ShareViewProps> = ({
  nodeId,
  groupTargets = [],
  orgPeopleTargets = [],
  otherPeopleTargets = [],
  organizationType = OrganizationTypes.PERSONAL,
  organizationName = 'Organization',
}) => {
  const { groupsFeatureFlag } = useFeatureFlagState();

  return (
    <div className={styles.shareViewSection}>
      <div className={styles.header}>
        <h3 className={styles.heading}>Add...</h3>
      </div>

      <div className={styles.content}>
        {groupsFeatureFlag && <GroupSharing nodeId={nodeId} groupTargets={groupTargets} />}

        {/* Organization */}
        {organizationType === OrganizationTypes.WORK && (
          <SharingWorkAccountView
            nodeId={nodeId}
            orgPeopleTargets={orgPeopleTargets}
            otherPeopleTargets={otherPeopleTargets}
            organizationName={organizationName}
          />
        )}

        {/* Personal */}
        {organizationType === OrganizationTypes.PERSONAL && (
          <SharingPersonalAccountView
            nodeId={nodeId}
            orgPeopleTargets={orgPeopleTargets}
            otherPeopleTargets={otherPeopleTargets}
          />
        )}
      </div>
    </div>
  );
};
